import { render } from "./MessageAttachmentPreview.vue?vue&type=template&id=4a70bb02&scoped=true"
import script from "./MessageAttachmentPreview.vue?vue&type=script&lang=js"
export * from "./MessageAttachmentPreview.vue?vue&type=script&lang=js"

import "./MessageAttachmentPreview.vue?vue&type=style&index=0&id=4a70bb02&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a70bb02"]])

export default __exports__